import { Button } from "flowbite-react"
import React, { useEffect, useRef, useState } from "react"
import { ReactComponent as ArrowIcon } from "../../images/arrow-2.svg"

const ScrollToTop = () => {
  const divRef = useRef()
  const [showScrollToTop, setShowScrollToTop] = useState(false)
  const handleScroll = () => {
    const divTop = divRef.current.offsetTop
    const scrollPosition = window.scrollY
    if (scrollPosition > divTop) {
      setShowScrollToTop(true)
    } else {
      setShowScrollToTop(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])
  return (
    <div ref={divRef}>
      {showScrollToTop && (
        <Button
          className="border z-10 fixed  duration-300 ease-in-out  w-10 md:w-12 h-10 md:h-12 right-7 bottom-24   rounded-[50%] border-white-250 md:right-6 md:bottom-20"
          outline
          onClick={scrollToTop}
          color="custom-theme"
          theme={{
            color: {
              "custom-theme": "bg-primary-100 hover:bg-white-100",
            },
            inner: {
              base: " !px-0 !py-0 flex items-center h-full text-[16px]  !bg-transparent !text-blue-100 ",
            },
          }}
        >
          <ArrowIcon className=" " />
        </Button>
      )}
    </div>
  )
}

export default ScrollToTop
